var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_370",
    "data-name": "Groupe 370",
    transform: "translate(-357.429 -134.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_405-3",
    "data-name": "Groupe 405-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_574",
    "data-name": "Trac\\xE9 574",
    d: "M391.429,182.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.436.059,14.747,0,17.6-.028,3.555-.039,3.624-.038,4.276.614.4.4,5.133,6.356,6.048,7.512,6.063,7.662,6.063,7.753,6.063,8.623v25.279A6.007,6.007,0,0,1,391.429,182.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V152.03c-1.46-2.042-8.436-10.829-10.492-13.338-.461,0-1.112.008-1.852.016C378.22,138.739,372.89,138.794,363.424,138.736Z",
    fill: "#3f82ef"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1391",
    "data-name": "Rectangle 1391",
    width: 16,
    height: 4,
    transform: "translate(366.429 155.691)",
    fill: "#3f82ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1392",
    "data-name": "Rectangle 1392",
    width: 22,
    height: 4,
    transform: "translate(366.429 162.691)",
    fill: "#3f82ef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 22,
    height: 4,
    transform: "translate(366.429 169.691)",
    fill: "#3f82ef"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.434ab18186f4bfb769899a32993aa12c.svg";
export { ForwardRef as ReactComponent };